import React, {useCallback} from "react";
import SwivuModal from "./SwivuModal.jsx";
import {WIDGET_KEYS} from "../../../other/constants/WidgetKeys.jsx";
import {Popup} from "@bryntum/schedulerpro";

class SwivuUserProfileEditor extends Popup {
  static get $name() {
    return "SwivuUserProfileEditor";
  }

  static get type() {
    return WIDGET_KEYS.swivuUserProfileEditorPopup;
  }

  static get configurable() {
    return {
      title: "Edit User Contact",
      autoClose: false,
      draggable: false,
      modal: true,
      closable: true,
      minHeight: "25em",
      maxWidth: "25em",
      items: {
        contactContainer: {
          type: "container",
          flex: "1 0 100%",
          autoUpdateRecord: true,
          defaults: {
            labelWidth: "8em",
          },
          items: {
            nameField: {
              type: "text",
              label: "Contact Name",
              name: "name",
            },
            phoneField: {
              type: WIDGET_KEYS.fieldPhone,
              label: "Contact Phone",
              name: "phone",
            },
            emailField: {
              type: WIDGET_KEYS.fieldEmail,
              label: "Contact Email",
              name: "email",
            },
            addressField: {
              type: "text",
              label: "Address",
              name: "address",
            },
            notesField: {
              type: "textarea",
              label: "Notes",
              height: "5em",
              name: "noteText",
            }
          }
        },
      },
    }
  }

  loadRecord(record, _context, _otherParams) {
    const { contactContainer } = this.widgetMap;
    contactContainer.record = record;
  }
}

SwivuUserProfileEditor.initClass()

const SwivuUserProfilePopup = ({ context, record, onClose, isShow, editorInstance }) => {
  const onShowHandler = useCallback((editor, otherParams = {}) => {
    editor.project = context.project;
    editor.loadRecord(record, context, otherParams);
    editorInstance.editorRef = editor;
  }, [context, editorInstance, record]);

  return (
    <SwivuModal
      widgetType={WIDGET_KEYS.swivuUserProfileEditorPopup}
      isShow={isShow}
      onHide={onClose}
      onShow={onShowHandler}
    />
  )
}

export default SwivuUserProfilePopup;